module.exports = __webpack_public_path__ + "img/feigang.2f99cf69.jpg";